import { getSubscriptionState } from 'core/utils/oneSignalHelpers';
import { useCallback, useEffect, useState } from 'react';

const useOneSignalPush = () => {
    const [loading, setLoading] = useState(true);
    const [pushNotifications, setPushNotifications] = useState(false);
    const [pushButtonDisabled, setPushButtonDisabled] = useState(true);

    const onSubscriptionChange = useCallback((subscribed: boolean) => {
        setPushNotifications(subscribed);
    }, []);

    useEffect(() => {
        // Push init
        // If we're on an unsupported browser, do nothing
        if (window?.OneSignal?.isPushNotificationsSupported && window.OneSignal.isPushNotificationsSupported()) {
            getSubscriptionState()
                .then(({ isOptedOut, isPushEnabled }) => {
                    setLoading(false);
                    setPushNotifications(isPushEnabled);
                    setPushButtonDisabled(!isPushEnabled && !isOptedOut);
                })
                .catch(err => {
                    setLoading(false);

                    // eslint-disable-next-line no-console
                    console.error(err);
                });

            // https://documentation.onesignal.com/docs/web-push-sdk#section-subscription-change
            window?.OneSignal?.on && window.OneSignal.on('subscriptionChange', onSubscriptionChange);
        } else {
            setLoading(false);
        }

        return () => {
            window?.OneSignal?.off && window.OneSignal.off('subscriptionChange', onSubscriptionChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onPushNotificationsChange = (checked: boolean) => {
        setLoading(true);

        // https://documentation.onesignal.com/docs/web-push-sdk#setsubscription
        window?.OneSignal?.setSubscription && window.OneSignal.setSubscription(checked);
    };

    return { pushLoading: loading, pushNotifications, pushButtonDisabled, onPushNotificationsChange } as const;
};

export default useOneSignalPush;
